import { StaticImage } from "gatsby-plugin-image"
import { Fragment, useEffect } from "react"

import { marketingClient } from "@trueskin-web/apis"
import { Seo } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"

import PageHeader from "./page-header"
import Steps from "./steps"

const WelcomeBack = () => {
  const { t } = useTranslation()

  useEffect(() => {
    marketingClient.trackEvent({
      name: marketingClient.EVENT_TYPES_ENUM.WELCOME_BACK_PAGE_OPENED,
    })
  }, [])

  return (
    <Fragment>
      <Seo title={t("Start.WelcomeBack.title")} />
      <div sx={{ mx: [null, "auto"], maxWidth: [null, "468px"] }}>
        <PageHeader
          title={t("Start.WelcomeBack.title")}
          image={
            <StaticImage
              src="./images/dr_sarah_3x.webp"
              alt=""
              width={64}
              height={64}
              sx={{ flexShrink: 0 }}
            />
          }
          subline={t("Start.WelcomeBack.subline")}
        />

        <Steps />
      </div>
    </Fragment>
  )
}

export default WelcomeBack
